import React, { Component } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import Icon from "../../../../icon";
import LineChartToolTip from "./custom-tooltip/line-chart-tooltip.component";
import Translation from "../../../../../components/common/translation/translation.component";
import CustomLegend from "../../../../common/graph/custom-legend.component";
import Moment from 'moment';

class UsageLineChart extends Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    this.props.setRef(this.chartRef);
  }

  render() {
    return (
      <div className="inventory-usage-spend-pl171">
        <div className="usage-line-chart-main usage-graph-title-container">
          <div className="monthly-usage-container details-info">
            <Icon
              customClassName="icon-info-circle icon-info-header"
              name="info-circle-solid"
              size="15px"
            />
            <div className="details-list">
              <span><Translation translationKey={"inventory_usage_spend_tooltip"} /></span>
            </div>
          </div>
        </div>
        <div className="usage-line-chart-main" ref={this.chartRef}>
          <div className="usage-graph-title-container">
            <h1>Usage Spend Monthly Trend</h1>
          </div>
          <div className="usage-line-chart-container responsive-large-container" ref={this.chartRef}>
            <CustomLegend
              ledger={this.props.ledger}
              payload={this.props.ledger.map(item => ({ dataKey: item.name }))}
            />
            <ResponsiveContainer width="100%" height={400}>
              <LineChart data={this.props.data} margin={{ left: -10, right: 130 }}>
                <CartesianGrid horizontal={false} stroke="#ccc" />
                <XAxis dataKey="Date" axisLine={false} tickLine={false} tick={{ fontSize: 13, fill: '#15181b' }} />
                <YAxis width={100} padding={{ bottom: 8 }} tickLine={false} axisLine={false} tick={{ fontSize: 13, fill: '#919eab', dx: -33, dy: 0 }} />
                <Tooltip content={<LineChartToolTip invoiceMonth={this.props.invoiceMonth} />} />
                {this.props.ledger.map((dataKey, index) =>
                  <Line key={index} type="monotone" dataKey={dataKey.name} stroke={dataKey.color} fill={dataKey.color} strokeWidth={2} />
                )}
              </LineChart>
            </ResponsiveContainer>
          </div>
          <div className="inventory-usage-spend-card-container">
            <div className="net-spend-card">
              <span>NET SPEND FOR</span>
              <span> {this.props.selectedMonth ? this.props.dateCurrentMonth.Date : Moment(new Date(this.props.dateCurrentMonth.Date)).local().format("MMM YYYY")}</span>
              <span>${this.props.dateCurrentMonth.TotalNetAmount}</span>
            </div>
            <div className="gross-spend-card gross-graph-card ">
              <span>GROSS SPEND FOR</span>
              <span> {this.props.selectedMonth ? this.props.dateCurrentMonth.Date : Moment(new Date(this.props.dateCurrentMonth.Date)).local().format("MMM YYYY")}</span>
              <span>${this.props.dateCurrentMonth.TotalGrossAmount}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UsageLineChart;
